import styled, { css } from 'styled-components';

export const Container = styled.div`
    ${({
        theme: {
            agent: {
                pages: {
                    config: {
                        formPanel: { hr },
                    },
                },
            },
        },
    }) => css`
        display: flex;
        flex-direction: column;
        gap: 20px;
        position: relative;

        .count-information {
            font-weight: 700;
            font-size: 13px;
            line-height: 19.5px;
            letter-spacing: 0.2px;
        }

        .eligible-description {
            font-weight: 500;
            font-size: 12px;
            line-height: 19.2px;
            letter-spacing: 0.1px;
        }

        .buttons-container {
            padding-top: 15px;
            border-top: 1px solid ${hr.color};
            margin-top: 15px;
            display: flex;
            gap: 8px;
            flex-direction: row-reverse;
            justify-content: start;

            @media (min-width: 64em) {
                flex-direction: row;
                justify-content: end;
            }

            button {
                height: 34px;
                padding: 8px 18px 8px 18px;
                font-size: 14px;
                font-weight: 600;
                line-height: 21px;
                letter-spacing: 0.2px;
                gap: 4px;
                border-radius: 6px;
                .desktop {
                    display: none;

                    @media (min-width: 64em) {
                        display: inline;
                    }
                }

                &.save-button {
                    width: 103px;
                    @media (min-width: 64em) {
                        width: 190px;
                    }
                }
            }
        }
    `}
`;

export const URLContentItem = styled.div`
    border-radius: 6px;
    width: 565px;
    height: 44px;
    border: 1px solid #f1f1f1;
    padding: 12px 8px 12px 8px;
    gap: 8px;
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.2px;
    color: black;

    p {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const URLContentProgressItem = styled.div`
    border-radius: 6px;
    width: 565px;
    height: fit-content;
    border: 1px solid #f1f1f1;
    padding: 12px 8px 12px 8px;
    gap: 32px;
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.2px;
    color: black;

    .first {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    div {
        p {
            flex: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
`;
